import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SelectSearchParty from "../AdminSearchExpense/SelectSearchParty";
import { useNavigate, useLocation } from "react-router-dom";
import "./AdmPlacement.css";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Container, Row, Col, Form } from "react-bootstrap";

const AdmAttendanceEntry = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const placementData = location.state?.placementData || {}; // Retrieve passed data

  const placementData = location.state?.placementData || null;

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [formData, setFormData] = useState({
    organizationName: "",
    trainingModule: "",
    duration: "",
    numParticipants: "",
    hrName: "",
  });

  const fromClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);

  const handleClear = () => {
    // Clear controlled form fields
    setFormData({
      organizationName: "",
      trainingModule: "",
      duration: "",
      numParticipants: "",
      hrName: "",
    });

    // Clear date fields
    setFromDate(null);
    setToDate(null);

    // Clear uncontrolled input refs if used elsewhere
    if (fromClassRef.current) fromClassRef.current.value = "";
    if (admissionNoRef.current) admissionNoRef.current.value = "";
    if (barcodeRef.current) barcodeRef.current.value = "";
    if (smsToRef.current) smsToRef.current.checked = false;
  };
  

  // Prefill form when placementData is available
  useEffect(() => {
    if (placementData) {
      setFormData({
        organizationName: placementData.companyname || "",
        trainingModule: placementData.module || "",
        duration: placementData.duration
          ? placementData.duration.replace(/\\/g, "\\\\")
          : "",
        numParticipants: placementData.participants || "",
        hrName: placementData.HRName || "",
      });

      setFromDate(
        placementData.fromdate ? new Date(placementData.fromdate) : null
      );
      setToDate(placementData.todate ? new Date(placementData.todate) : null);
    }
  }, [placementData]);
  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formatLocalDate = (date) => {
    if (!(date instanceof Date)) return date;
    const offset = date.getTimezoneOffset() * 60000; // Get timezone offset in milliseconds
    return new Date(date.getTime() - offset).toISOString().split("T")[0]; // Adjust for timezone
  };

  const handleSubmit = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both From Date and To Date");
      return;
    }

    const academicSessionId = localStorage.getItem("academicSessionId") || "1";
    const orgId = localStorage.getItem("orgId") || "1";
    const branchId = localStorage.getItem("branchId") || "1";
    const userId = sessionStorage.getItem("userId") || "1";

    const formattedFromDate = formatLocalDate(fromDate);
    const formattedToDate = formatLocalDate(toDate);

    const payload = {
      companyname: formData.organizationName,
      module: formData.trainingModule,
      duration: formData.duration,
      fromdate: formattedFromDate,
      todate: formattedToDate,
      participants: formData.numParticipants,
      HRName: formData.hrName,
      academic_year_id: academicSessionId,
      org_id: orgId,
      branch_id: branchId,
      created_by: userId,
    };

    try {
      let response;
      if (placementData?.id) {
        // If placementData exists and has an ID, update the record
        response = await fetch(
          `${ApiUrl.apiurl}TRAINING_PLACEMENT/Update/${placementData.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
      } else {
        // Otherwise, create a new record
        response = await fetch(
          `${ApiUrl.apiurl}TRAINING_PLACEMENT/create/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
      }

      if (response.ok) {
        const data = await response.json();
        alert(
          placementData?.id
            ? "Placement updated successfully!"
            : "Placement created successfully!"
        );
        console.log(
          placementData?.id
            ? "Placement updated successfully:"
            : "Placement created successfully:",
          data
        );
          handleClear();
      } else {
        const errorData = await response.json();
        alert("Error saving placement. Please try again.");
        console.error("Error saving placement:", errorData);
      }
    } catch (error) {
      alert(
        "Something went wrong. Please check your internet connection and try again."
      );
      console.error("Error saving placement:", error);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-2">
            <div className="card-body">
              <p
                className="text-center fw-bold mb-3"
                style={{ fontSize: "18px" }}
              >
                STUDENT PLACEMENTS/WORKSHOPS/SEMINARS
              </p>

              <div className="row mb-3 mt-3">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2 "
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/training")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* <div
                className="col-12"
                style={{
                  border: "1px solid #ccc",
                  marginTop: "10px",
                  padding: "15px",
                }}
              >
                <div className="settings-section">
                  <label className="settings-label">
                    Name of Organization/Company
                  </label>
                  <input
                    type="text"
                    className="input-field"
                    name="organizationName"
                    value={formData.organizationName}
                    onChange={handleChange}
                  />
                </div>

                <div className="settings-section">
                  <label className="settings-label">Training Module*</label>
                  <input
                    type="text"
                    className="input-field"
                    name="trainingModule"
                    value={formData.trainingModule}
                    onChange={handleChange}
                  />
                </div>

                <div className="settings-section">
                  <label className="settings-label">Duration*</label>
                  <input
                    type="number"
                    className="input-field"
                    name="duration"
                    value={formData.duration}
                    onChange={handleChange}
                  />
                  <input
                    type="text"
                    className="input-field"
                    name="duration"
                    value={formData.duration}
                    onChange={handleChange}
                  />
                </div>

                <div className="settings-section">
                  <label className="settings-label">From Date*</label>
                  <DatePicker
                    selected={fromDate}
                    onChange={(date) => setFromDate(date)}
                    className="input-field"
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select From Date"
                  />
                </div>

                <div className="settings-section">
                  <label className="settings-label">To Date*</label>
                  <DatePicker
                    selected={toDate}
                    onChange={(date) => setToDate(date)}
                    className="input-field"
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select To Date"
                  />
                </div>

                <div className="settings-section">
                  <label className="settings-label">
                    Number of Participants
                  </label>
                  <input
                    type="number"
                    className="input-field"
                    name="numParticipants"
                    value={formData.numParticipants}
                    onChange={handleChange}
                  />
                </div>

                <div className="settings-section">
                  <label className="settings-label">HR Name</label>
                  <input
                    type="text"
                    className="input-field"
                    name="hrName"
                    value={formData.hrName}
                    onChange={handleChange}
                  />
                </div>
              </div> */}

              <Row className="justify-content-center">
                <Col
                  className="p-3"
                  xs={12}
                  md={8}
                  style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                >
                  <Form onSubmit={(e) => e.preventDefault()}>
                    {/* Organization Name */}
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Label>
                          Name of Organization/Company{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                      </Col>
                      <Col md={6}>
                        <Form.Control
                          type="text"
                          className="form-control detail"
                          name="organizationName"
                          value={formData.organizationName}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[A-Za-z\s]*$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                          required
                        />
                      </Col>
                    </Row>

                    {/* Training Module */}
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Label>
                          Training Module{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                      </Col>
                      <Col md={6}>
                        <Form.Control
                          type="text"
                          className="form-control detail"
                          name="trainingModule"
                          value={formData.trainingModule}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[A-Za-z\s]*$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                          required
                        />
                      </Col>
                    </Row>

                    {/* Duration */}
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Label>
                          Duration <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                      </Col>
                      <Col md={6}>
                        <Form.Control
                          type="text"
                          name="duration"
                          className="form-control detail"
                          value={formData.duration}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[0-9]*$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                          required
                        />
                      </Col>
                    </Row>

                    {/* From Date */}
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Label>
                          From Date <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                      </Col>
                      <Col md={6}>
                        <input
                          type="date"
                          id="from-date"
                          className="form-control detail"
                          value={fromDate || ""}
                          onChange={(e) => setFromDate(e.target.value)}
                          required
                        />
                      </Col>
                    </Row>

                    {/* To Date */}
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Label>
                          To Date <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                      </Col>
                      <Col md={6}>
                        <input
                          type="date"
                          id="to-date"
                          className="form-control detail"
                          value={toDate || ""}
                          onChange={(e) => setToDate(e.target.value)}
                          required
                        />
                      </Col>
                    </Row>

                    {/* Number of Participants */}
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Label>
                          Number of Participants{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                      </Col>
                      <Col md={6}>
                        <Form.Control
                          type="text"
                          name="numParticipants"
                          className="form-control detail"
                          value={formData.numParticipants}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[0-9]*$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                          required
                        />
                      </Col>
                    </Row>

                    {/* HR Name */}
                    <Row>
                      <Col md={6}>
                        <Form.Label>HR Name</Form.Label>
                      </Col>
                      <Col md={6}>
                        <Form.Control
                          type="text"
                          className="form-control detail"
                          name="hrName"
                          value={formData.hrName}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[A-Za-z\s]*$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                        />
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdmAttendanceEntry;



